import { post, API_END_POINT } from 'js/Core/http';
import {generateUID} from 'js/Core/utils';
export const SET_APPOINTMENT_FIELD = 'SET_APPOINTMENT_FIELD';
export const TOGGLE_APPOINTMENT_FIELD = 'TOGGLE_APPOINTMENT_FIELD';
import { addError, hideError } from 'js/Actions/Errors.action';
import {validateData} from 'js/Core/validatorService'; 
import {lang} from 'js/Core/lang';
import {setStep} from './Steps.action';
import {gaEvent, gaTiming} from 'js/Core/ga';

export const submitAppointment = () => (dispatch, getState) => {
    const { selectedCalendar,
            selectedTimeline, 
            selectedProducts, 
            selectedEmployees,
            bookerInfo
        } = getState().appointments,
        {
            message, 
            customerName, 
            fullName,
            phoneNumber, 
            email,             
            emailSubscribe,
            birthDate,
            sex,
            age
        } = bookerInfo;
    let stateAppoint = getState();
    let {storeId, id} = stateAppoint.person;
    let {fieldsDefination} = stateAppoint;
    let details = [];
    selectedProducts.map(valPro => details.push({employeeId: selectedEmployees,productId: valPro}));
    let result = {
        id: generateUID(),
        shopId: stateAppoint.shop.id,
        scheduleDate: selectedCalendar,
        fromTime: selectedTimeline.from,
        toTime: selectedTimeline.to,
        notes: message + '\r\n' + sex + '\r\n' + age ,//+ '\r\n'+ emailSubscribe,
        status: stateAppoint.shop.webAppointmentStatus,
        channel: stateAppoint.shop.bookingChannel,
        bookerInfo: {
            fullName : fieldsDefination.fullName !== 'HIDDEN' ? fullName : '',
            displayName: fieldsDefination.displayName !== 'HIDDEN' ? customerName : '',
            phoneNumber: fieldsDefination.phone !== 'HIDDEN' ? phoneNumber : '',
            emailAddress: fieldsDefination.email !== 'HIDDEN' ? email : '',
            birthDate: fieldsDefination.birthDate !== 'HIDDEN' ? birthDate : ''
        },
        details
    }
    let query = id !== '' ? '?storeId=' + storeId + '&personId='+id : '';
    let messageShopAlert = localStorage.getItem('flagCloseAlert');
    return post(`${API_END_POINT}/${stateAppoint.shop.apiVersion}/shop/saveAppointment${query}`, result)
    .then(response => response.json())
    .then(result => {
        gaEvent('SunSale', 'Book an appointment', result.bookingStatus === 'SUCCESS' ? 'Successfully' : 'Failed/' + result.bookingStatus);
        gaTiming('SunSale', 'Book an appointment', result.bookingStatus === 'SUCCESS' ? 'Successfully' : 'Failed/'+ result.bookingStatus);        
        let {shop} = stateAppoint;
        if(shop.urlRedirect === ''){
            dispatch(_setAppointmentField([{key: 'statusSubmit', value: result.bookingStatus}]));
            let elFooter = document.getElementsByClassName('form-submit')[0];
            elFooter.classList.remove('prevent_loop_submit');
            localStorage.setItem('firstLoadGa', '1');
            if(messageShopAlert === '1'){
                localStorage.setItem('flagNotShowAlert', '1');
            }
        }else{
            if(result.bookingStatus === 'SUCCESS'){
                window.location.href = shop.urlRedirect;
                localStorage.removeItem('idProduct');
            }else{
                dispatch(_setAppointmentField([{key: 'statusSubmit', value: result.bookingStatus}]));
                let elFooter = document.getElementsByClassName('form-submit')[0];
                elFooter.classList.remove('prevent_loop_submit');
                localStorage.setItem('firstLoadGa', '1');
                if(messageShopAlert === '1'){
                    localStorage.setItem('flagNotShowAlert', '1');
                }
            }
        }

    })
    .catch(error => {
        let elFooter = document.getElementsByClassName('form-submit')[0];
        elFooter.classList.remove('prevent_loop_submit');
        gaEvent('SunSale', 'Book an appointment', 'Failed/'+error.message);
        gaTiming('SunSale', 'Book an appointment', 'Failed/'+error.message);
        localStorage.setItem('firstLoadGa', '1');
        dispatch(_setAppointmentField([{key: 'statusSubmit', value: 'ERROR SERVER'}]));
        if(messageShopAlert === '1'){
            localStorage.setItem('flagNotShowAlert', '1');
        }
    });
}

export const validateAppointmentField = () => (dispatch, getState) => {
    let {bookerInfo,selectedTimeline, selectedProducts} = getState().appointments,
        {customerName, fullName,  email, phoneNumber, birthDate} = bookerInfo,
        {fieldsDefination} = getState();
    let form = {
        info : {
            name: customerName,
            fullName,
            phoneNumber,
            emailAddress: email,
            scheduleDate: selectedTimeline,
            birthDate,
            notes: ''
        },
        productId: selectedProducts[0],
        dataValid: false
    }
    let requireField = {
        displayName: (fieldsDefination.displayName === 'REQUIRED' || (customerName !== '' && fieldsDefination.customerName !== 'HIDDEN')) ? true : false,
        email: (fieldsDefination.email === 'REQUIRED' || (email !== '' && fieldsDefination.email !== 'HIDDEN')) ? true : false,
        fullName: (fieldsDefination.fullName === 'REQUIRED' || (fullName !== '' && fieldsDefination.fullName !== 'HIDDEN')) ? true : false,
        phone: (fieldsDefination.phone === 'REQUIRED' || (phoneNumber !== '' && fieldsDefination.phone !== 'HIDDEN')) ? true : false,
        birthDate: (fieldsDefination.birthDate === 'REQUIRED' || (birthDate !== '' && fieldsDefination.birthDate !== 'HIDDEN')) ? true : false
    }
    
    let result = validateData(form, lang.message, requireField);
    let firstElError = '';
    var msgError = '';

    
    for (var key in result) {                
        if (result.hasOwnProperty(key) && result[key].invalid && msgError === '') {
            msgError = result[key].invalid;            
            if(firstElError === ''){
                firstElError = key;
            }
        }
    }
    if(msgError === true){
        dispatch(addError(result));
        let elFooter = document.getElementsByClassName('form-submit')[0];
        elFooter.classList.remove('prevent_loop_submit');
        let elIdError = document.getElementById(firstElError);
        let topOff = elIdError.getBoundingClientRect().top + window.scrollY - 100;
        window.scroll(0,topOff);	
    }else{
        dispatch(setAppointmentField([{
            key: 'validateAppointment',
            value: true
        }]))        
        dispatch(setStep(3));
        dispatch(hideError());
        window.scroll(0,0);
        //dispatch(submitAppointment())
    }
}

export const setAppointmentField = (listValue) => (dispatch, getState) => {
    return dispatch(_setAppointmentField(listValue));
}

export const toggleAppointmentField = (listValue) => (dispatch, getState) => {
    return dispatch(_toggleAppointmentField(listValue));
}

const _setAppointmentField = (listValue) => ({
    type: SET_APPOINTMENT_FIELD,
    payload: {
        listValue
    }
})

const _toggleAppointmentField = (listValue) => ({
    type: TOGGLE_APPOINTMENT_FIELD,
    payload: {
        listValue
    }
})
